import { render, staticRenderFns } from "./landZuAdd.vue?vue&type=template&id=6a828f11"
import script from "./landZuAdd.vue?vue&type=script&lang=js"
export * from "./landZuAdd.vue?vue&type=script&lang=js"
import style0 from "./landZuAdd.vue?vue&type=style&index=0&id=6a828f11&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports